module.exports = __webpack_public_path__ + "static/profile-pic-real-ccb57d15c343f68f0ffa4b90654c444b.jpg";